import { CmsApiScrollTrackingBlockData } from 'modules/cms/api/types/blocks/CmsApiScrollTrackingBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsScrollTrackingBlock } from './CmsScrollTrackingBlock';

export const CmsScrollTrackingBlockMapping: CmsBlockMapping<CmsApiScrollTrackingBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.FULL,
    Component: CmsScrollTrackingBlock,

    AmpComponent: CmsScrollTrackingBlock,
  };
